
export default function VideoSection() {
  return (
    <section className="relative w-full bg-black">
      <div className="w-full aspect-video">
        <iframe
          title="vimeo-player"
          className="w-full h-full"
          src="https://player.vimeo.com/video/1169736769?h=c56a4c9eed&badge=0&autopause=0&player_id=0&app_id=58479&title=0&byline=0&portrait=0"
          frameBorder="0"
          referrerPolicy="strict-origin-when-cross-origin"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          allowFullScreen
        ></iframe>
      </div>
    </section>
  );
}
